export function isValidImageUrl (URL) {
  return new Promise(res => {
    const tester = new Image();
    tester.onload = () => res(true);
    tester.onerror = () => res(false);
    tester.src = URL;
  })
}